<template>
    <div class="ppv2-space-y-6">
        <!-- Adresse légale -->
        <!-- <BaseInput
      v-model="formData.legalAddress"
      :label="$t('configuration.tax.fields.legalAddress.label')"
      :tooltipMsg="$t('configuration.tax.fields.legalAddress.description')"
      :placeholder="$t('configuration.tax.fields.legalAddress.placeholder')"
      required
      >
      <template #leftIcon>

      </template>
</BaseInput> -->

        <!-- Pays -->
        <BaseSelect
            v-model="formData.pays.id"
            :label="$t('configuration.tax.fields.country.label')"
            :tooltipMsg="$t('configuration.tax.fields.country.description')"
            :options="countries"
            option-label="name"
            option-value="id"
            @input="onCountryChanged"
            required
            :error="errors.pays"
        >
            <template #leftIcon>
                <svg class="ppv2-w-4 ppv2-h-4 ppv2-text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    ></path>
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                </svg>
            </template>
        </BaseSelect>

        <!-- Soumis à la TVA -->
        <BaseRadioGroup
            v-model="formData.is_vat_applicable"
            :label="$t('configuration.tax.fields.vatApplicable.label')"
            :tooltipMsg="$t('configuration.tax.fields.vatApplicable.description')"
            :options="vatOptions"
            required
            :error="errors.is_vat_applicable"
        >
            <template #leftIcon> </template>
        </BaseRadioGroup>

        <!-- Numéro TVA -->
        <BaseInput
            v-if="formData.is_vat_applicable"
            v-model="formData.vat_number"
            :label="$t('configuration.tax.fields.vatNumber.label')"
            :tooltipMsg="$t('configuration.tax.fields.vatNumber.description')"
            :placeholder="$t('configuration.tax.fields.vatNumber.placeholder')"
        >
            <template #leftIcon> </template>
        </BaseInput>

        <!-- Devise -->
        <BaseSelect
            v-model="formData.currency_id"
            :label="$t('configuration.tax.fields.currency.label')"
            :tooltipMsg="$t('configuration.tax.fields.currency.description')"
            :options="currencies"
            option-label="code"
            option-value="id"
            required
            :error="errors.currency_id"
        >
            <template #leftIcon> </template>
        </BaseSelect>
    </div>
</template>

<script>
import BaseInput from '../../../Shared/BaseInput.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import BaseRadioGroup from '../../../Shared/BaseRadioGroup.vue'

export default {
    name: 'TaxInformationForm',
    props: {
        countries: {
            required: true,
        },
        currencies: {
            required: true,
        },
    },
    components: { BaseInput, BaseSelect, BaseRadioGroup },
    data() {
        return {
            formData: {
                // legalAddress: '',
                pays: {
                    id: null,
                    name: '',
                },
                is_vat_applicable: true,
                vat_number: '',
                currency_id: null,
            },
            errors: {},
        }
    },
    computed: {
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
        vatOptions() {
            return [
                { label: this.$t('configuration.tax.fields.vatApplicable.options.yes'), value: true },
                { label: this.$t('configuration.tax.fields.vatApplicable.options.no'), value: false },
            ]
        },
    },
    created() {
        this.initializeForm()
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler(newVal) {
                this.$emit('update', newVal)
                // Clear error when field is updated
                Object.keys(this.errors).forEach((field) => {
                    const val = newVal[field]
                    let isPopulated = false
                    if (field === 'pays') {
                        isPopulated = val && val.id
                    } else {
                        isPopulated = val !== null && val !== undefined && (typeof val !== 'string' || val.trim() !== '')
                    }

                    if (isPopulated) {
                        this.$delete(this.errors, field)
                    }
                })
            },
            deep: true,
        },
    },
    methods: {
        initializeForm() {
            const fields = [/*'legalAddress',*/ 'pays', 'is_vat_applicable', 'vat_number', 'currency_id']
            fields.forEach((field) => {
                if (this.establishment.hasOwnProperty(field)) {
                    if (field == 'currency' && this.establishment[field] == null) {
                        this.formData[field] = { id: null }
                    } else {
                        this.formData[field] = this.establishment[field]
                    }
                }
            })
        },
        currencyLabel(option) {
            return `${option.name} (${option.symbol})`
        },
        getFormData() {
            return this.formData
        },
        setFormData(data) {
            this.formData = { ...this.formData, ...data }
        },
        validateForm() {
            this.errors = {}
            let isValid = true
            const required = ['pays', 'is_vat_applicable', 'currency_id']
            required.forEach((field) => {
                const val = this.formData[field]
                let isEmpty = !val || (typeof val === 'string' && val.trim() === '')

                if (field === 'pays') {
                    isEmpty = !val || !val.id
                }

                if (isEmpty) {
                    this.$set(this.errors, field, 'Ce champ est requis')
                    isValid = false
                }
            })
            return isValid
        },
        resetForm() {
            this.formData = {
                // legalAddress: '',
                pays: {
                    id: null,
                    name: '',
                },
                is_vat_applicable: true,
                vat_number: '',
                currency_id: null,
            }
        },
        onCountryChanged(selectedId) {
            const selectedCountry = this.countries.find((country) => country.id == selectedId)
            if (selectedCountry) {
                this.formData.pays.name = selectedCountry.name
                this.formData.currency_id = selectedCountry?.currency?.id
            } else {
                this.formData.pays.id = null
                this.formData.pays.name = ''
            }
            this.$emit('update', this.formData)
        },
        getValidationErrors() {
            const errors = {}
            const fields = ['pays', 'is_vat_applicable', 'currency_id']
            fields.forEach((field) => {
                const val = this.formData[field]
                let isEmpty = !val || (typeof val === 'string' && val.trim() === '')
                if (field === 'pays') isEmpty = !val || !val.id

                if (isEmpty) {
                    errors[field] = this.$t(`configuration.tax.fields.${field}.requiredError`)
                }
            })
            return errors
        },
    },
}
</script>

<style scoped>
/* styles custom éventuels */
</style>
